import dynamic from 'next/dynamic'
import Image from 'next/image'
import { createImageUrl } from '@/utils/image/create-image-url'
import { cn } from '@/utils/styles/cn'

const CustomVideoPlayer = dynamic(() => import('./custom-video-player'), { ssr: false })

interface IRestaurantDetailVideoProps {
    url: string
    thumbnailUrl?: string
    autoPlay?: boolean
    className?: string
}

/**
 * Video tile for the gallery row. The (invisible) thumbnail defines the tile's
 * intrinsic aspect ratio before the video metadata is available, the player
 * then fills the tile. Falls back to 9:16 (the reel format) without thumbnail.
 */
export const RestaurantDetailVideo = ({
    url,
    thumbnailUrl,
    autoPlay = false,
    className,
}: IRestaurantDetailVideoProps) => {
    const resizedThumbnailUrl = thumbnailUrl
        ? createImageUrl(thumbnailUrl, { height: 400 })
        : undefined

    return (
        <div
            className={cn(
                'relative h-full shrink-0 overflow-hidden rounded-l bg-bg-neutral-surface',
                !resizedThumbnailUrl && 'aspect-[9/16]',
                className
            )}
        >
            {resizedThumbnailUrl && (
                <Image
                    unoptimized
                    src={resizedThumbnailUrl}
                    alt=""
                    height={0}
                    width={0}
                    className="h-full w-auto invisible"
                />
            )}

            <CustomVideoPlayer
                url={url}
                thumbnailUrl={resizedThumbnailUrl}
                autoPlay={autoPlay}
                className="absolute inset-0"
            />
        </div>
    )
}
